const { get } = require('lodash');
const Amplify = require('aws-amplify');
const { publicRuntimeConfig } = require('config');
const { settings } = publicRuntimeConfig;

const awsAuthConfig = () => {
    Amplify.default.configure({
        Auth: {

            // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
            identityPoolId: get(settings, 'identityPoolId'),

            // REQUIRED - Amazon Cognito Region
            region: 'us-east-1',

            // OPTIONAL - Amazon Cognito Federated Identity Pool Region
            // Required only if it's different from Amazon Cognito Region
            // identityPoolRegion: 'us-east-1',

            // OPTIONAL - Amazon Cognito User Pool ID
            userPoolId: get(settings, 'cognitoPoolIDENV'),

            // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
            userPoolWebClientId: get(settings, 'cognitoClientIDENV'),
            oauth: {
                domain: get(settings, 'domain'),
                scope: get(settings, 'oathClaims'),
                redirectSignIn: get(settings, 'signInUrl'),
                redirectSignOut: get(settings, 'signOutUrl'),
                responseType: get(settings, 'grantFlow')
            },

            // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
            mandatorySignIn: false

            // OPTIONAL - customized storage object
            // storage: new MyStorage(),

        // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
        // authenticationFlowType: 'USER_PASSWORD_AUTH'
        }
    });

    Amplify.Auth.configure();
};

module.exports = { awsAuthConfig };
